export const DEV_PHRASE = 'bottom drive obey lake curtain smoke basket hold race lonely fit walk';
export const DEV_SEED = '0xfac7959dbfe72f052e5a0c3c8d6530f202b02fd8f9f5ca3580ec8deb7797479e';
